import React from 'react';

import { DARK } from 'constants/colors';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Menu, MenuItem, SxProps, styled } from '@mui/material';

const StyledContextMenu = styled(Box)`
  display: flex;
  border-radius: 4px;
`;

const StyledButton = styled('button')`
  padding: 5px;
  border-radius: 50%;
  border: none;
  background: none;
  width: 30px;
  height: 30px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

interface ContextMenuProps {
  options: string[];
  onOpen?: (open: boolean, event?: React.MouseEvent<SVGElement>) => void;
  onOptionClick: (option: string) => void;
  clickType?: 'lmb' | 'rmb';
  sx?: SxProps;
  menuSx?: SxProps;
}

export default function ContextMenu({
  options,
  onOptionClick,
  onOpen,
  clickType = 'lmb',
  sx,
  menuSx
}: ContextMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<SVGElement | null>(null);
  const open = Boolean(anchorEl);

  const onClickHandler = clickType === 'lmb' ? 'onClick' : 'onContextMenu';

  function handleOpen(e: React.MouseEvent<SVGElement>) {
    e.stopPropagation();
    e.preventDefault();
    onOpen?.(true, e);
    setAnchorEl(e.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
    onOpen?.(false);
  }

  function handleMenuItemClick(option) {
    onOptionClick(option);
    handleClose();
  }

  if (options.length == 0) {
    return null;
  }

  return (
    <StyledContextMenu sx={sx}>
      <StyledButton {...{ [onClickHandler]: handleOpen }}>
        <MoreVertIcon sx={{ color: DARK }} fontSize="small" />
      </StyledButton>
      {open && (
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={menuSx}>
          {options.map((option) => (
            <MenuItem key={option} onClick={() => handleMenuItemClick(option)}>
              {option}
            </MenuItem>
          ))}
        </Menu>
      )}
    </StyledContextMenu>
  );
}
